import * as React from 'react';

import TimeCommitmentEffortText from 'bundles/learner-progress/components/item/TimeCommitmentEffortText';
import type { Item } from 'bundles/learner-progress/types/Item';

import _t from 'i18n!nls/learner-progress';

type Props = {
  item: Item;
  className: string;
};

const WiseFlowEffortText = ({ item, className, ...rest }: Props) => {
  if (item.isGraded) {
    return (
      <span {...rest} className={className}>
        {_t('Graded')}
      </span>
    );
  } else if (item.isCompleted) {
    return (
      <span {...rest} className={className}>
        {_t('Completed')}
      </span>
    );
  } else if (item.isSubmitted) {
    return (
      <span {...rest} className={className}>
        {_t('Submitted')}
      </span>
    );
  } else if (item.isStarted) {
    return (
      <span {...rest} className={className}>
        {_t('Started')}
      </span>
    );
  }

  return <TimeCommitmentEffortText timeCommitment={item.timeCommitment} className={className} {...rest} />;
};

export default WiseFlowEffortText;
